import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  query: gql`
    query terminalTransactionsList($transactionId: ID!, $isReversal: Boolean!) {
      transaction(transactionId: $transactionId, isReversal: $isReversal) {
        id
        transactionId
        date
        type: operationName
        status
        statusName
        responseCode
        isReversal
        hasReversal

        requestAmount
        transactionCurrencyCode
        billingAmount
        fee
        cardCurrencyCode

        paymentSystem
        pan
        originType: transactionType
        ucafIndicator
        posEntryMode

        acquiringId
        acquiringName
        companyId
        companyName
        merchantName
        merchantCountry: country
        terminalId
        device

        authCode
        mcc
        rrn
        ecommerceIndicator

        smsStatus
        smsDate
        smsPhone
        smsText
      }
    }
  `,
  variables: ({ transactionId, isReversal }) => {
    return {
      transactionId,
      isReversal,
    };
  },
  config: {
    // pollInterval: 300000,
    errorPolicy: "none",
    notifyOnNetworkStatusChange: true,
    // fetchPolicy: "network-only",
  },
  propTypes: {
    transactionId: PropTypes.string,
    isReversal: PropTypes.bool,
  },
  dataKey: "transaction",
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/transaction.js